import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.growth-scale-form', () => {
  import('./internal/growth-scale-form').then(({ default: Component }) => Component());
});
